export default Object.freeze({
  Approve: 1,
  Reject: 2,
  Skip: 3,
});
